'use strict';

(function () {
  'use strict';

  angular.module('msCore').directive('msActionItemAni', msActionItemAni);

  /**
   * A directive that animates a modal into view, animates it away, then removes those animated elements from the DOM.
   *
   * This directive makes use of Tween.js for animating: https://github.com/tweenjs/tween.js
   * Arrow functions cannot be passed to Tween.js's update function as Tween.js uses the step's current values as `this` when it called onUpdate().
   *
   * This directive is template-agnostic, although as of writing this, it is only designed to be used with the msActionItem template.
   */
  msActionItemAni.$inject = ['$window', '$document', '$timeout', '$q', 'actionItemAnimationSvc'];
  var STOP_ANI = false;
  var pause1 = void 0,
      pause2 = void 0;
  var pauseTimeouts = [pause1, pause2];

  function msActionItemAni($window, $document, $timeout, $q, actionItemAnimationSvc) {
    var actionItemTweens = actionItemAnimationSvc.animations;
    var directive = {
      link: link,
      restrict: 'A',
      scope: false
    };
    return directive;

    function link(scope, element, attrs) {

      attrs.$observe('aniTrigger', function (val) {
        if (val === 'true') {
          // Define all of the elements required by this animation.
          var modalWrapperEl = cloneForAnimation($document[0].querySelector('[ms-action-item-wrapper="' + attrs.msActionItemAni + '"]'));
          var modalEl = angular.element(modalWrapperEl[0].querySelector('[ms-action-item-target="' + attrs.msActionItemAni + '"]'));
          var targetLi = angular.element(modalEl[0].querySelector('[ms-action-item-target-li="' + attrs.msActionItemAni + '"]'));
          var faderEl = angular.element(modalWrapperEl[0].querySelector('[ms-action-item-fader="' + attrs.msActionItemAni + '"]'));
          applyPreAnimationCss(modalEl, faderEl, modalWrapperEl);

          // Start animation here. Calling animate() begins the animation loop. Tween.start() will be called on each animation
          // when it is time for it to begin.
          STOP_ANI = false;
          animate();

          // There are three steps to this animation:
          //   1. Slide the modal in form the bottom of the screen
          //   2. Pop the new action item into view.
          //   3. Slide the modal out of view again
          // Each step returns a promise, which is resolved when the animation is completed.
          // There is a pause between each animation to allow the user to read what is on screen.
          // At the end, remove the cloned element from the DOM when everything is done.
          // Set the STOP_ANI flag to true to stop calling TWEEN.update().
          toggleModal(modalEl, faderEl, true).then(function () {
            pause1 = $timeout(function () {
              popAnimation(targetLi).then(function () {
                pause2 = $timeout(function () {
                  toggleModal(modalEl, faderEl).then(function () {
                    modalWrapperEl.remove();
                    STOP_ANI = true;
                  });
                }, 2000);
              });
            }, 500);
          });
        }
      });

      scope.$on('$destroy', function () {
        pauseTimeouts.forEach(function (timeout) {
          return $timeout.cancel(timeout);
        });
        TWEEN.getAll().forEach(function (tween) {
          return tween.stop();
        });
        STOP_ANI = true;
      });
    }

    ////////////////////////////////

    // Creates a clone of the element for animation purposes.
    // In order to ensure the animated elements appear layered above all other elements,
    // these animated elements must be a direct child of <body>.
    // This makes the assumption that the element to be cloned already has a CSS class that sets display: none,
    // Otherwise you will see the newly cloned element appear in the viewport before the animation has begun...which is janky.
    function cloneForAnimation(element) {
      var clone = angular.element(element).clone();
      angular.element($document[0].body).append(clone);
      return clone;
    }

    // Animates its target into view from opacity: 0 to opacity: 1.
    // Does not change the display property of its target.
    function popAnimation(element) {
      var popDone = $q.defer();
      var burst = actionItemTweens.burstAni(element);
      var popTween = actionItemTweens.popInTween(element).onComplete(function () {
        burst.run();
        popDone.resolve();
      });

      popTween.start();
      return popDone.promise;
    }

    // Set the inital css properties of each element
    // This makes the assumption that the initial CSS on the element being animated
    // is exactly what the user will see after it is in view.
    // i.e. Design the elements with CSS as you want them to be seen, and this function will
    // set the styles to what they should look like at t=0 (right before the animation beings)
    function applyPreAnimationCss(modalEl, faderEl, modalWrapperEl) {
      modalWrapperEl.css({
        display: 'block'
      });
      modalEl.css({
        transform: 'translateX(' + actionItemAnimationSvc.elementToCoords(modalEl).translate.x + 'px) translateY(100vh)'
      });
      faderEl.css({
        opacity: 0
      });
    }

    function toggleModal(modalEl, faderEl, openIt) {
      var modalToggleComplete = $q.defer();
      var toggleFaderTween = actionItemTweens.faderTween(faderEl, openIt);
      var toggleModalTween = actionItemTweens.showHideModalTween(modalEl, openIt).onComplete(function () {
        modalToggleComplete.resolve();
      });

      toggleModalTween.start();
      toggleFaderTween.start();

      return modalToggleComplete.promise;
    }
  }

  // Recursive loop that calls TWEEN.update() ~60 times per second.
  // TWEEN.update() increases the values of all the active Tweens, moving all animations to the next frame.
  function animate() {
    if (STOP_ANI) {
      return;
    }
    TWEEN.update();
    requestAnimationFrame(animate);
  }
})();